export const app = {
  connectToYourWhatsappNumber: 'Mit Ihrer WhatsApp-Nummer verbinden',
  connectYourWhatsappBotWithYourWhatsappNumber: 'Verbinden Sie Ihren WhatsApp-Bot mit Ihrer WhatsApp-Nummer',
  connect: 'Verbinden',
};
